export const CHAT_LIMITS = {
    bodyMax: 1000,
    /** 방 화면이 열려 있는 동안의 폴링 주기(ms). SSE는 추후 최적화(SPEC D0). */
    pollMs: 4000,
};
// ── 신고 (관리자 전달) ─────────────────────────────────────────
/** 신고 유형. 직장 내 괴롭힘은 심각 분류로 관리자에게 플래그된다. */
export const REPORT_CATEGORIES = [
    { code: 'spam', label: '스팸·광고' },
    { code: 'abuse', label: '욕설·비방' },
    { code: 'fraud', label: '사기 의심' },
    { code: 'harassment', label: '직장 내 괴롭힘' },
    { code: 'other', label: '기타' },
];
export function reportCategoryLabel(code) {
    return REPORT_CATEGORIES.find((c) => c.code === code)?.label ?? '기타';
}
/** 도착 핑을 누를 수 있는 시간 창(약속 시각 기준 ±분). */
export const ARRIVAL_WINDOW_MIN = 60;
/** T-30 리마인더(분). */
export const APPOINTMENT_REMINDER_MIN = 30;
//# sourceMappingURL=chat.js.map